var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 10h28v24H8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.297 28h-2.195v-8.273a7.568 7.568 0 0 1-2.836 1.664v-1.993c.573-.187 1.195-.543 1.867-1.066.672-.523 1.133-1.134 1.383-1.832h1.78V28zM21.992 28l2.992-4.273-2.867-4.024h2.68l1.469 2.281 1.547-2.28h2.578l-2.813 3.929L30.648 28h-2.695l-1.687-2.57L24.563 28z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed1X);
export default __webpack_public_path__ + "static/media/speed1X.db309e1f736743c82fb008f90f8d9295.svg";
export { ForwardRef as ReactComponent };